import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { loginWithGoogle } from "../../firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";

export default function GoogleSignInButton({ redirect = "/" }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      await loginWithGoogle(result.user);
      navigate(redirect);
    } catch (err) {
      console.error("Google sign-in error:", err);
      setError("Google sign-in failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {error && <p className="text-red-500 text-center">{error}</p>}
      <Button
        onClick={handleGoogleLogin}
        variant="ghost"
        disabled={loading}
        className="w-full flex items-center justify-center gap-2 border border-surface text-text rounded-md py-2 hover:bg-gray-50 transition"
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          className="w-5 h-5"
        />
        {loading ? "Signing in..." : "Sign in with Google"}
      </Button>
    </div>
  );
}
